<form [formGroup]="qualificationForm" (ngSubmit)="saveQualification(inProgress)">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="ri-file-marked-line me-1 font-20 text-primary"></i>{{qualificationForm.value.id?'Update':'Add'}}
      Qualification
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-6">
        <label for="qualificationType" class="form-label">Qualification Type <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class="ri-bar-chart-horizontal-fill"></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter qualification type"
            formControlName="qualificationType" [ngClass]="{'is-invalid': submitted && q.qualificationType.errors}"  autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && q.qualificationType.errors">
            <span *ngIf="q.qualificationType.errors.required">Please provide qualification type</span>
            <span *ngIf="q.qualificationType.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="degreeName" class="form-label">Degree Name <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class="ri-pie-chart-box-line"></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter degree name"
            [ngClass]="{'is-invalid': submitted && q.degreeName.errors}" formControlName="degreeName"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && q.degreeName.errors">
            <span *ngIf="q.degreeName.errors.required">Please provide a degree name.</span>
            <span *ngIf="q.degreeName.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="institutionName" class="form-label">Institution Name <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class="ri-building-4-line"></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter institution name"
            [ngClass]="{'is-invalid': submitted && q.institutionName.errors}" formControlName="institutionName"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && q.institutionName.errors">
            <span *ngIf="q.institutionName.errors.required">Please provide a valid instituation name.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="startDate" class="form-label">Start Date <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
              class='bx bx-calendar'></i></span>
          <input type="date" class="form-control ps-1" id="startDate" formControlName="startDate"
            [ngClass]="{'is-invalid': submitted && q.startDate.errors}"  autocomplete="off"  />
          <div class="invalid-feedback" *ngIf="submitted && q.startDate.errors">
            <span *ngIf="q.startDate.errors.required">Please select a date.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="endDate" class="form-label">End Date </label>
        <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
              class='bx bx-calendar'></i></span>
          <input type="date" class="form-control ps-1" id="endDate" formControlName="endDate"
            [ngClass]="{'is-invalid': submitted && q.endDate.errors}"  autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && q.endDate.errors">
            <span *ngIf="q.endDate.errors.required">Please select a date.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="specialization" class="form-label">Specialization</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class="ri-medal-line"></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter specialization"
            [ngClass]="{'is-invalid': submitted && q.specialization.errors}" formControlName="specialization"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && q.specialization.errors">
            <span *ngIf="q.specialization.errors.required">Please provide a specialization.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="gradeOrScore" class="form-label">Grade OR SCore</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class="ri-discount-percent-line"></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter grade or score"
            [ngClass]="{'is-invalid': submitted && q.gradeOrScore.errors}" formControlName="gradeOrScore"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && q.gradeOrScore.errors">
            <span *ngIf="q.gradeOrScore.errors.required">Please provide a grade or score.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="documentUrl" class="form-label">Document File</label>
        <div class="input-group">
          <input 
            type="file" 
            class="custom-file-input form-control" 
            id="documentUrl" 
            accept=".jpg,.jpeg,.png,.pdf" 
            (change)="onFileSelected($event)">
        </div>
      </div>
      <div class="col-md-6">
        <label for="remarks" class="form-label">Remarks</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bxs-purchase-tag'></i></span>
          <input type="text" class="form-control ps-1" id="remarks" placeholder="Enter remarks"
            formControlName="remarks" autocomplete="off" />
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
          <label class="form-check-label" for="disabled">Disabled</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
        class="bx bx-x"></i>Close</button>
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
      <ng-container *ngIf="inProgress?.value=='true'">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{qualificationForm.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>{{qualificationForm.value.id?'Save Changes':'Save'}}
      </ng-container>
    </button>
  </div>
</form>